import { useQuery } from "@tanstack/react-query";
import { extractPaginatedCollection } from "../../utils/apiResponse";

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {string} deps.language
 * @param {number} deps.pageIndex
 * @param {number} deps.pageSize
 * @param {string} [deps.id]
 * @param {boolean} [deps.enabled=true]
 */
export function useGetPolicies({
  callApiWithWorker,
  language,
  pageIndex,
  pageSize,
  id,
  enabled = true,
}) {
  const isSingle = Boolean(id);

  return useQuery({
    queryKey: isSingle
      ? ["policy", id, language]
      : ["policies", language, pageIndex, pageSize],
    enabled,
    queryFn: async () => {
      const url = isSingle
        ? `/policy-templates/${encodeURIComponent(id)}?language=${encodeURIComponent(language)}`
        : `/policy-templates?language=${encodeURIComponent(language)}&page=${pageIndex}&size=${pageSize}&include_details=true`;

      const body = await callApiWithWorker(url, { method: "GET" });

      if (isSingle) return body;

      return extractPaginatedCollection(body);
    },
    keepPreviousData: !isSingle,
    staleTime: 30_000,
  });
}
